import { Text } from '@scale/scaleui-radix';
import HTTPError from 'react-scale/lib/httpError';

const WebinarError: React.FC<{ error: unknown }> = ({ error }) => {
  let message = '';

  if (error instanceof HTTPError) {
    message = `${error.status}: ${error.response?.error}`;
  } else if (error instanceof Error) {
    message = error.message;
  } else if (typeof error === 'string') {
    message = error;
  }

  return (
    <div className="w-full h-full flex items-center justify-center">
      <div className="text-center">
        <div>
          <Text size="4" weight="bold">
            Something went wrong
          </Text>
        </div>
        {message && (
          <div>
            <Text size="3">Error: {message}</Text>
          </div>
        )}
      </div>
    </div>
  );
};

export default WebinarError;
